/*
 * @Author: hongqi
 * @LastEditors: hongqi
 * @Date: 2020-12-02 10:15:06
 * @LastEditTime: 2020-12-30 15:13:26
 */
import Vue from 'vue'
import Vuex from 'vuex'
import {
    httpPost,
    httpGet
} from '../http/axios'
import Lockr from 'lockr'
import GLOBAL from '@/config'
import API from '@/api/api'


Vue.use(Vuex)

export default new Vuex.Store({
    //这里放全局参数
    state: {
        userInfo: '', // 用户信息
        qiniuInfo: '', // 七牛云信息
        service: '', // 服务信息
    },
    //这里是set方法
    mutations: {
        SET_USERINFO: (state, data) => {
            state.userInfo = data
        },
        SET_QINIU: (state, data) => {
            state.qiniuInfo = data;
        },
        SET_SERVICE: (state, data) => {
            state.service = data;
        },
    },
    //这里是get方法
    getters: {
        userInfo: state => state.userInfo,
        qiniuInfo: state => state.qiniuInfo,
        service: state => state.service,
    },
    //这个部分我暂时用不上
    actions: {
        // 登录
        Login({
            commit
        }, params) {
            return new Promise((resolve, reject) => {
                let url = API.login
                httpPost(url, params).then(response => {
                    if (response.code === GLOBAL.SUCCESS_CODE) {
                        let data = response.data
                        Lockr.set('token', data.token) // 保存登录token
                        commit('SET_USERINFO', data) // 保存用户信息
                        resolve(response)
                    } else {
                        reject(response)
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 获取用户信息
        UserInfo({
            commit
        }) {
            return new Promise((resolve, reject) => {
                let url = API.user_info
                let params = {
                    token: Lockr.get('token')
                }
                httpPost(url, params).then(response => {
                    console.log('response---->', response);
                    if (response.code === GLOBAL.SUCCESS_CODE) {
                        const data = response.data.user_info
                        commit('SET_USERINFO', data)
                        resolve(response)
                    } else {
                        resolve(response)
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 退出
        LogOut({
            commit
        }) {
            return new Promise((resolve, reject) => {
                Lockr.rm('token') // 清除token
                commit('SET_USERINFO', null) // 清除用户信息
                resolve()
            })
        },
        // 获取七牛云信息
        Service({
            commit
        }) {
            new Promise((resolve, reject) => {
                let url = API.customer_service
                let params = {
                    token: Lockr.get('token')
                }
                httpPost(url, params).then(response => {
                    if (response.code === GLOBAL.SUCCESS_CODE) {
                        const data = response.data
                        commit('SET_SERVICE', data)
                        resolve(response)
                    } else {
                        resolve(response)
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 服务信息
        GetQiniu({
            commit
        }) {
            return new Promise((resolve, reject) => {
                let url = '/api/qiniu/up_token'
                httpGet(url).then(response => {
                    if (response.code === GLOBAL.SUCCESS_CODE) {
                        const data = response
                        commit('SET_QINIU', data) // 存储七牛云信息
                        resolve(response)
                    } else {
                        reject(response)
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        }
    },
    //这里是我自己理解的是为了给全局变量分组，所以需要写提前声明其他store文件，然后引入这里
    modules: {}
})